var _g, _g2, _g3, _g4, _g5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGoal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 167.59,
    height: 150.661,
    viewBox: "0 0 167.59 150.661",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group_116407",
    "data-name": "Group 116407",
    transform: "translate(-57.099 -146.268)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122387",
    "data-name": "Path 122387",
    d: "M216.2,421.163c0,.535-19.7.968-43.992.968s-43.992-.434-43.992-.968,19.7-.968,43.992-.968S216.2,420.629,216.2,421.163Z",
    transform: "translate(-36.588 -140.933)",
    fill: "#606060",
    opacity: 0.25,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_116402",
    "data-name": "Group 116402",
    transform: "translate(57.099 146.268)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122388",
    "data-name": "Path 122388",
    d: "M185.447,219.379c20.592,24.1,24.885,52.056-.443,75.877-19.965,18.775-54.423,12.693-75.015-11.411s-20.394-58.075.443-75.877S164.854,195.275,185.447,219.379Z",
    transform: "translate(-76.43 -172.55)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1977",
    "data-name": "Ellipse 1977",
    cx: 49.623,
    cy: 56.684,
    rx: 49.623,
    ry: 56.684,
    transform: "translate(0 64.466) rotate(-40.508)",
    fill: "#183240"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1978",
    "data-name": "Ellipse 1978",
    cx: 42.302,
    cy: 48.321,
    rx: 42.302,
    ry: 48.321,
    transform: "translate(10.998 66.068) rotate(-40.508)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1979",
    "data-name": "Ellipse 1979",
    cx: 35.566,
    cy: 40.626,
    rx: 35.566,
    ry: 40.626,
    transform: "translate(21.118 67.544) rotate(-40.508)",
    fill: "#183240"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1980",
    "data-name": "Ellipse 1980",
    cx: 28.564,
    cy: 32.629,
    rx: 28.564,
    ry: 32.629,
    transform: "translate(31.636 69.076) rotate(-40.508)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1981",
    "data-name": "Ellipse 1981",
    cx: 21.497,
    cy: 24.555,
    rx: 21.497,
    ry: 24.555,
    transform: "translate(42.254 70.624) rotate(-40.508)",
    fill: "#183240"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_1982",
    "data-name": "Ellipse 1982",
    cx: 14.337,
    cy: 16.377,
    rx: 14.337,
    ry: 16.377,
    transform: "matrix(0.76, -0.65, 0.65, 0.76, 53.01, 72.191)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122389",
    "data-name": "Path 122389",
    d: "M208.375,290.253c2.545,2.979,2.494,7.2-.114,9.428s-6.785,1.619-9.331-1.36-2.494-7.2.114-9.428S205.83,287.274,208.375,290.253Z",
    transform: "translate(-129.105 -218.956)",
    fill: "#183240"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_116403",
    "data-name": "Group 116403",
    transform: "translate(131.647 150.822)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122390",
    "data-name": "Path 122390",
    d: "M319.193,174.845s5.591-19.2,8.476-19.2,4.073,6.449,4.073,6.449Z",
    transform: "translate(-266.492 -155.649)",
    fill: "#ffa523"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122391",
    "data-name": "Path 122391",
    d: "M320.22,182.916s19.2-5.591,19.2-8.476-6.449-4.073-6.449-4.073Z",
    transform: "translate(-267.02 -163.221)",
    fill: "#ffa523"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6445",
    "data-name": "Line 6445",
    x1: 65.761,
    y2: 64.014,
    transform: "translate(0 6.762)",
    fill: "none",
    stroke: "#004a67",
    strokeWidth: 2.097
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_116404",
    "data-name": "Group 116404",
    transform: "translate(131.647 183.316)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122392",
    "data-name": "Path 122392",
    d: "M353.968,236.447s13.193-15.022,15.807-13.8.959,7.567.959,7.567Z",
    transform: "translate(-284.383 -222.575)",
    fill: "#0070c0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122393",
    "data-name": "Path 122393",
    d: "M354.463,246.185s19.757,3.064,20.979.451-4.117-6.421-4.117-6.421Z",
    transform: "translate(-284.638 -231.651)",
    fill: "#0070c0"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6446",
    "data-name": "Line 6446",
    x1: 86.681,
    y2: 30.144,
    transform: "translate(0 8.138)",
    fill: "none",
    stroke: "#004a67",
    strokeWidth: 2.097
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_116405",
    "data-name": "Group 116405",
    transform: "translate(131.647 221.598)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122394",
    "data-name": "Path 122394",
    d: "M358.975,329.859s19.124-5.831,20.7-3.416-3.167,6.939-3.167,6.939Z",
    transform: "translate(-286.959 -313.995)",
    fill: "#61cecb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122395",
    "data-name": "Path 122395",
    d: "M358.677,335.522s15.187,13,17.6,11.424-.122-7.626-.122-7.626Z",
    transform: "translate(-286.806 -318.967)",
    fill: "#61cecb"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6447",
    "data-name": "Line 6447",
    x1: 89.57,
    y1: 19.986,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#004a67",
    strokeWidth: 2.097
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_116406",
    "data-name": "Group 116406",
    transform: "translate(131.647 221.598)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122396",
    "data-name": "Path 122396",
    d: "M331.183,393.837s19.794,2.816,20.2,5.672-5.807,4.945-5.807,4.945Z",
    transform: "translate(-272.661 -348.97)",
    fill: "#a353ea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122397",
    "data-name": "Path 122397",
    d: "M330.311,395s8.252,18.211,11.108,17.8,3.119-6.96,3.119-6.96Z",
    transform: "translate(-272.212 -349.568)",
    fill: "#a353ea"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_6448",
    "data-name": "Line 6448",
    x1: 72.68,
    y1: 56.035,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#004a67",
    strokeWidth: 2.097
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoal);
export default __webpack_public_path__ + "static/media/Goal.e7b0d362b247f88c528608226b4a8dc6.svg";
export { ForwardRef as ReactComponent };